import * as React from "react"
import marketingUrls from "shared/marketing-website/constants/urls"

import { CUSTOM_REGION_NAME_MAX_LENGTH } from "app/static/frontend/custom-regions/constants"

export const helpTextConstants = {
    header: "Change Region",
    searchBarPlaceholder: "Type to find a region, and hit enter to select it...",
}

export const formValidationConstants = {
    noNameError: "Custom region must have a name.",
    maxLengthNameError: `Custom region name must have a maximum of ${CUSTOM_REGION_NAME_MAX_LENGTH} characters`,
    specialCharError: "Custom region name must only include alphanumeric characters, spaces, and dashes",
    duplicateNameError: "There is already a custom region with that name. Choose a unique name for this custom region.",
    noRegionsError: "Custom region must have at least one region.",
}

const euSVG = (
    large = false,
) => `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="31" height="${
    large ? 30 : 25
}">
        <defs>
            <g id="s">
                <g id="c">
                    <path id="t" d="M0,0v1h0.5z" transform="translate(0,-1)rotate(18)"></path>
                    <use xlink:href="#t" transform="scale(-1,1)"></use>
                </g>
                <g id="a">
                    <use xlink:href="#c" transform="rotate(72)"></use>
                    <use xlink:href="#c" transform="rotate(144)"></use>
                </g>
                <use xlink:href="#a" transform="scale(-1,1)"></use>
            </g>
        </defs>
        <g class="eu-star" transform="scale(${large ? 1.8 : 1.5})translate(${large ? "7,9" : "11,8"})">
            <use xlink:href="#s" y="-6"></use><use xlink:href="#s" y="6"></use><g id="l">
                <use xlink:href="#s" x="-6"></use>
                <use xlink:href="#s" transform="rotate(150)translate(0,6)rotate(66)"></use>
                <use xlink:href="#s" transform="rotate(120)translate(0,6)rotate(24)"></use>
                <use xlink:href="#s" transform="rotate(60)translate(0,6)rotate(12)"></use>
                <use xlink:href="#s" transform="rotate(30)translate(0,6)rotate(42)"></use>
            </g>
            <use xlink:href="#l" transform="scale(-1,1)"></use>
        </g>
    </svg>`

export const regionIcons = {
    allIconString: `<span class="stateface stateface-us" />`,
    allIcon: <span className="stateface stateface-us" />,

    euSVG: euSVG(),
    euIcon: <div className="eu-icon-dropdown" dangerouslySetInnerHTML={{ __html: euSVG() }} />,

    topfederalIcon: <i style={{ float: "left", marginLeft: "3px", marginTop: "20px" }} className="fa fa-bank" />,
    topstatesIcon: (
        <i
            style={{ float: "left", marginLeft: "4px", marginTop: "18px", fontSize: "23px" }}
            className="fa fa-compass"
        />
    ),
    toplocalIcon: (
        <i
            style={{ float: "left", marginLeft: "4px", marginTop: "20px", fontSize: "20px", marginRight: "9px" }}
            className="fa fa-building"
        />
    ),
    topcustomIcon: (
        <i
            style={{ float: "left", marginRight: "8px", marginLeft: "4px", marginTop: "18px", fontSize: "23px" }}
            className="fa fa-star"
        />
    ),
    topEUIcon: <div className="eu-icon-topmenu-old" dangerouslySetInnerHTML={{ __html: euSVG(true) }}></div>,
    globalIcon: (
        <i
            style={{ float: "left", marginRight: "8px", marginLeft: "4px", marginTop: "18px", fontSize: "23px" }}
            className="fa fa-globe"
        />
    ),
    internationalIcon: (
        <i
            style={{ float: "left", marginRight: "10px", marginLeft: "0px", marginTop: "20px", fontSize: "16px" }}
            className="fa fa-map-o"
        />
    ),
}

export const newRegionIcons = {
    allIconString: `<span class="stateface stateface-us" />`,
    allIcon: <span className="stateface stateface-us" />,

    euSVG: euSVG(),
    euIcon: <div className="eu-icon-dropdown" dangerouslySetInnerHTML={{ __html: euSVG() }} />,

    topfederalIcon: <i className="fa fa-bank" />,
    topstatesIcon: <i className="fa fa-compass" />,
    toplocalIcon: <i className="fa fa-building" />,
    topcustomIcon: <i className="fa fa-star" />,
    topEUIcon: <div className="eu-icon-topmenu" dangerouslySetInnerHTML={{ __html: euSVG(true) }}></div>,
    globalIcon: <i className="fa fa-globe" />,
    internationalIcon: <i className="fa fa-map-o" />,
}

export const MAJOR_REGION_TOOLTIPS = {
    [DjangIO.app.models.SupportedRegion.federal.value]: "The United States Federal government.",
    [DjangIO.app.models.SupportedRegion.states.value]:
        "Every state government in the United States that is available to you.",
    [DjangIO.app.models.SupportedRegion.local.value]:
        "Every municipal and county government in the United States that is available to you.",
    [DjangIO.app.models.SupportedRegion.eu.value]: "The government of the European Union.",
    [DjangIO.app.models.SupportedRegion.all_regions.value]: "Every region in the US that is available to you.",
    [DjangIO.app.models.SupportedRegion.states_and_local.value]:
        "Every state, municipal, and county government in the United States that is available to you.",
    [DjangIO.app.models.SupportedRegion.international.value]:
        "Every region that is not in the United States that is available to you.",
    [DjangIO.app.models.SupportedRegion.user_global.value]: "Every region available to you.",
}

export const PRODUCT_PAGE_PATHS = {
    [DjangIO.app.models.SupportedRegion.federal.value]: marketingUrls.federalProduct,
    [DjangIO.app.models.SupportedRegion.states.value]: marketingUrls.stateProduct,
    [DjangIO.app.models.SupportedRegion.local.value]: marketingUrls.localProduct,
    [DjangIO.app.models.SupportedRegion.eu.value]: marketingUrls.euProduct,
    [DjangIO.app.models.SupportedRegion.all_regions.value]: marketingUrls.federalProduct,
    [DjangIO.app.models.SupportedRegion.states_and_local.value]: marketingUrls.stateProduct,
    [DjangIO.app.models.SupportedRegion.international.value]: marketingUrls.internationalProduct,
}

const constants = {
    ...helpTextConstants,
    ...newRegionIcons,
    ...formValidationConstants,
    MAJOR_REGION_TOOLTIPS,
    PRODUCT_PAGE_PATHS,
}

export default constants
